<template>
    <vue-scroll v-loading="items.meta.loading">
        <div class="page-header">
            <h1>Closed Orders</h1>
        </div>
        <div class="float-left">
            Actions
            <el-select
                style="width: auto"
                v-model="action.name"
                placeholder="Select Action"
                :disabled="!action.orders.length"
            >
                <el-option
                    :key="index"
                    :label="action.name"
                    :value="action.value"
                    v-for="(action, index) in actions"
                >
                </el-option>
            </el-select>
            <el-button @click="applyAction" :disabled="!action.orders.length"
                >Apply</el-button
            >
            <el-input
                placeholder="Search Orders..."
                style="width: 250px"
                v-model="filter.search"
            />
        </div>
        <div class="float-right">
            <el-checkbox
                v-model="filter.paid_at"
                @change="getUnpaid"
                class="paid-checkbox"
                >Unpaid</el-checkbox
            >
            Filter by:
            <el-date-picker
                @change="onChangeDateFilter"
                type="date"
                placeholder="Filter Date"
                v-model="filter.created_at"
                :picker-options="dateFilterOptions"
            >
            </el-date-picker>
            <el-select
                @change="onChangeCorporation"
                clearable
                filterable
                placeholder="Corporation..."
                style="width: 200px"
                v-model="filter.corporation_id"
            >
                <el-option label="Independent" value="independent" />
                <el-option
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    v-for="item in corporations.data"
                />
            </el-select>
        </div>
        <div class="clearfix"></div>
        <el-table
            :data="items.data"
            @sort-change="onSortChange"
            class="mt-20"
            ref="table"
            v-loading="loading"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
                label="Order #"
                prop="id"
                sortable="custom"
                width="125"
            >
                <template v-slot="scope">
                    {{ scope.row.id }}
                </template>
            </el-table-column>
            <el-table-column label="Paid" prop="paid_at" width="100">
                <template v-slot="{ row }">
                    <el-switch
                        :value="!!row.paid_at"
                        @change="onChangeInvoicePaid(row, $event)"
                    />
                </template>
            </el-table-column>
            <el-table-column
                label="Customer"
                prop="tenant.name"
                sortable="custom"
            />
            <el-table-column
                label="Order Placed"
                prop="created_at"
                sortable="custom"
                width="200"
            >
                <template v-slot="scope">
                    {{ scope.row.created_at | florida_short_datetime }}
                </template>
            </el-table-column>
            <el-table-column
                label="Issue"
                prop="formatted_month"
                sortable="custom"
                width="200"
            />
            <el-table-column
                label="Status"
                prop="formatted_status"
                width="200"
            />
            <el-table-column label="Tracking Info" width="200">
                <template v-slot="{ row }">
                    <a :href="`/web-api/order/${row.id}/track`" target="_blank"
                        >Track Order <i class="mdi mdi-open-in-new"
                    /></a>
                </template>
            </el-table-column>
            <el-table-column prop="actions" width="120px">
                <template v-slot="{ row }">
                    <el-button-group>
                        <router-link
                            :to="{
                                name: Routes.VIEW_ORDER,
                                params: { id: row.id },
                            }"
                            class="el-button el-button--default text-decoration-none"
                        >
                            <i class="mdi mdi-eye"></i>
                            View
                        </router-link>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <app-pagination
            :disabled="loading"
            class="mt-10"
            :pagination="items.meta.pagination"
            v-if="items.meta.pagination"
            @current-change="onCurrentChange"
        />
    </vue-scroll>
</template>

<script>
import { mapState } from "vuex";
import * as ApprovalStatus from "../../../constants/approval-status";
import formatters from "../../../mixins/table/formatters";
import * as Routes from "@/constants/routes";
import qs from "qs";
import _ from "lodash";
import moment from "moment";
import Vue from "vue";

function getData(params = null) {
    params = {
        page: 1,
        closed: 1,
        include: "tenant",
        sort_by: "created_at",
        sort_order: "desc",
        ...params,
    };
    return window.axios.get(`/web-api/order?${qs.stringify(params)}`);
}

export default {
    mixins: [formatters],
    beforeRouteEnter(to, from, next) {
        getData(to.query).then((response) => {
            next((vm) => {
                _.extend(
                    vm.currentQuery,
                    _.pick(to.query, ["sort_by", "sort_order", "page"])
                );
                _.extend(vm.currentQuery.filter, _.get(to, "query.filter"));
                vm.setData(response);
            });
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.items.meta.loading = true;
        getData(to.query)
            .then((response) => {
                this.setData(response);
                next();
            })
            .finally(() => (this.items.meta.loading = false));
    },
    data() {
        return {
            Routes,
            ApprovalStatus,
            dialogVisible: false,
            form: new Form({
                name: null,
                slug: null,
                logo: null,
                location: {
                    street: null,
                    city: null,
                    state: null,
                    zip: null,
                },
            }),
            filter: {
                created_at: null,
                search: "",
                corporation_id: null,
                paid_at: false,
            },
            logo_src: null,
            editingItem: null,
            loading: false,
            dateFilterOptions: {
                shortcuts: [
                    {
                        text: "Today",
                        onClick(picker) {
                            picker.$emit("pick", new Date());
                        },
                    },
                    {
                        text: "Yesterday",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit("pick", date);
                        },
                    },
                    {
                        text: "A week ago",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", date);
                        },
                    },
                ],
            },
            items: {
                data: [],
                meta: {
                    pagination: null,
                    loading: false,
                },
            },
            currentQuery: {
                filter: {
                    created_at: null,
                    search: "",
                },
                page: 1,
                sort_by: "created_at",
                sort_order: "desc",
            },
            actions: [
                {
                    name: "Paid",
                    value: "paid",
                },
                {
                    name: "Unpaid",
                    value: "unpaid",
                },
            ],
            action: {
                name: null,
                orders: [],
            },
        };
    },
    computed: {
        ...mapState({
            corporations: (state) => state.corporations,
        }),
    },
    mounted() {
        this.filter.search = _.get(this.$route, "query.filter.search", "");
        let created_at_string = _.get(this.$route, "query.filter.created_at");
        if (created_at_string) {
            let created_at = moment(created_at_string);
            if (created_at.isValid()) {
                this.filter.created_at = created_at.toDate();
            }
        }
        Vue.nextTick(() => {
            this.updateTableSorting();
        });
    },
    methods: {
        updateTableSorting() {
            let sort_by = this.currentQuery.sort_by;
            switch (sort_by) {
                case "community":
                    sort_by = "tenant.name";
                    break;
                case "issue_month":
                    sort_by = "formatted_month";
                    break;
            }
            this.$refs.table.sort(
                sort_by,
                this.currentQuery.sort_order === "desc"
                    ? "descending"
                    : "ascending"
            );
        },
        setData(response) {
            this.items.data = response.data.data;
            this.items.meta.pagination = response.data.meta.pagination;
        },
        getData({ page = 1 }) {
            this.loading = true;
            getData({
                page,
                search: this.currentQuery.filter.search,
            })
                .then((response) => {
                    this.setData(response);
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => (this.loading = false));
        },
        onCurrentChange(page) {
            this.currentQuery.page = page;
            this.updateRoute();
        },
        onChangeDateFilter(date) {
            this.currentQuery.filter.created_at = date
                ? moment(date).format("YYYY-MM-DD")
                : null;
            this.updateRoute();
        },
        onSortChange({ prop, order }) {
            let sort_order = null;
            let sort_by = prop;
            switch (sort_by) {
                case "tenant.name":
                    sort_by = "community";
                    break;
                case "formatted_month":
                    sort_by = "issue_month";
                    break;
            }
            if (order) {
                sort_order = order === "descending" ? "desc" : "asc";
            } else {
                sort_by = null;
            }
            let has_update =
                JSON.stringify(
                    _.pick(this.currentQuery, ["sort_by", "sort_order"])
                ) !==
                JSON.stringify({
                    sort_by,
                    sort_order,
                });
            this.currentQuery.sort_by = sort_by;
            this.currentQuery.sort_order = sort_order;
            if (has_update) {
                this.updateRoute();
            }
        },
        updateRoute() {
            this.$router.push({
                name: Routes.CLOSED_ORDERS,
                query: this.currentQuery,
            });
        },
        onChangeLogo(e) {
            window.Utils.getFileImageData(e.currentTarget).then((response) => {
                this.logo_src = response;
                this.form.logo = e.target.files[0];
            });
        },
        editItem(item) {
            this.$router.push({
                name: "EditOrder",
                params: {
                    id: item.id,
                },
            });
        },
        onChangeInvoicePaid(order, value) {
            window.axios
                .put(`/web-api/order/${order.id}`, {
                    is_paid: value,
                })
                .then((response) => {
                    order.paid_at = response.data.paid_at;
                    this.$notify.success({
                        message: `Order #${order.id} marked as ${
                            value ? "paid" : "unpaid"
                        }.`,
                    });
                });
        },
        onChangeCorporation(value) {
            switch (value) {
                case null:
                case "":
                    this.currentQuery.filter = _.omit(
                        this.currentQuery.filter,
                        ["corporation_id"]
                    );
                    break;
                case "independent":
                    this.currentQuery.filter.corporation_id = null;
                    break;
                default:
                    this.currentQuery.filter.corporation_id = value;
                    break;
            }
            this.updateRoute();
        },
        getUnpaid(value) {
            if (value) {
                this.currentQuery.filter.paid_at = true;
                this.updateRoute();
            } else {
                this.currentQuery.filter = _.omit(this.currentQuery.filter, [
                    "paid_at",
                ]);
                this.updateRoute();
            }
        },
        handleSelectionChange(val) {
            this.action.orders = val;
        },
        applyAction() {
            let vm = this;
            if (!vm.action.orders.length) {
                vm.$notify.error({
                    message: "Please select orders for apply action.",
                });
                return;
            }
            if (!vm.action.name) {
                vm.$notify.error({
                    message: "Please select action for apply action.",
                });
                return;
            }
            window.axios
                .post("/web-api/apply-action/orders", vm.action)
                .then((response) => {
                    //console.log(response);
                    vm.updateRoute();
                    vm.$notify.success({
                        message: "Orders updated successfully.",
                    });
                })
                .catch((error) => {
                    console.log(error);
                    vm.items.meta.loading = false;
                });
        },
    },
    watch: {
        "filter.search": _.debounce(function () {
            this.currentQuery.filter.search = this.filter.search;
            this.updateRoute();
        }, 500),
    },
};
</script>

<style>
.paid-checkbox {
    margin-right: 15px !important;
}
.paid-checkbox .el-checkbox__label {
    font-size: 20px !important;
}
</style>
